import React, { useState, useRef, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./portfolio.css";

const allProjects = [
  {
    id: "1",
    title: "Medical Outreach",
  },
  {
    id: "2",
    title: "Women and Children",
  },

  {
    id: "3",
    title: "Rural Communities",
  },

];

const projectTitles = [
  "All",
  ...new Set(allProjects.map((project) => project.title)),
];

function Portfolio() {
  const [curOption, setCurOption] = useState("All");

  const portfoliolist = useRef(null);

  useEffect(() => {
    const elements = [...portfoliolist.current.children];

    elements.forEach((element) => {
      element.style.display = "none";
    });

    if (curOption === "All") {
      elements.forEach((element) => {
        element.style.display = "inline-block";
      });
    }

    if (curOption === "Medical Outreach") {
      elements.forEach((element) => {
        if (element.classList.contains("medical-outreach")) {
          element.style.display = "inline-block";
        }
      });
    }

    if (curOption === "Women and Children") {
      elements.forEach((element) => {
        if (element.classList.contains("women-and-Children")) {
          element.style.display = "inline-block";
        }
      });
    }

    if (curOption === "Rural Health") {
      elements.forEach((element) => {
        if (element.classList.contains("rural-health")) {
          element.style.display = "inline-block";
        }
      });
    }

  }, [curOption]);

  return (
    <div className="main-portfolio">
      <title>doctor near me</title>
      <Container>
        <Row className="d-flex align-items-center" style={{display: "flex"}}>
          <Col xs={12}>
            <div className="portfolio-title">
              <title>doctor near me</title>
              <span className="sub-title">Dr. Isioma Okobah Foundation</span>
            </div>
          </Col>
          <Col lg={6}>
            <div className="portfolio-title">
              <title>doctor near me</title>
              <h2 className="h2-title" >Featured Projects</h2>
            </div>
          </Col>
          <Col lg={6}>
            <div className="portfolio-tabbing">
              <title>doctor near me</title>
              <ul>
                {projectTitles.map((proTitle, index) => {
                  return (
                    <li key={index} onClick={() => setCurOption(proTitle)}>
                      <span
                        className={`${
                          proTitle === curOption ? "filter active" : "filter"
                        }`}
                      >
                        {proTitle}
                      </span>
                    </li>
                  );
                })}
              </ul>
            </div>
          </Col>

          <Col xs={12}>
            <div className="portfolio-list-box">
              <title>doctor near me</title>
              <div ref={portfoliolist}>
                {/* 1 */}
                <div className="portfolio md-6 medical-outreach">
                  <title>doctor near me</title>
                  <div className="portfolio-wrapper">
                    <title>doctor near me</title>
                    <div
                      className="portfolio-img back-img"
                      style={{
                        backgroundImage:
                          "url('https://i.ibb.co/HXL2t72/dr-isioma-okobah-honduras.jpg')",
                      }}
                    ></div>
                    <div className="portfolio-wrapper-text">
                      <title>doctor near me</title>
                      <h3 className="h3-title">Medical Outreach</h3>
                      <p>Honduras 2007</p>
                    </div>
                  </div>
                </div>
                {/* 2 */}
                <div className="portfolio md-3 medical-outreach">
                  <title>doctor near me</title>
                  <div className="portfolio-wrapper">
                    <title>doctor near me</title>
                    <div
                      className="portfolio-img back-img"
                      style={{
                        backgroundImage:
                          "url('https://i.ibb.co/x6HV8j3/dr-isioma-okobah-medical-outreach2.jpg')",
                      }}
                    ></div>
                    <div className="portfolio-wrapper-text">
                      <title>doctor near me</title>
                      <h3 className="h3-title">Medical Outreach</h3>
                      <p>Igbodo 2017</p>
                    </div>
                  </div>
                </div>
                {/* 3 */}
                <div className="portfolio md-3 medical-outreach">
                  <title>doctor near me</title>
                  <div className="portfolio-wrapper">
                    <title>doctor near me</title>
                    <div
                      className="portfolio-img back-img"
                      style={{
                        backgroundImage:
                          "url('https://i.ibb.co/2YW17G2/dr-isioma-okobah-medical-outreach7.jpg')",
                      }}
                    ></div>
                    <div className="portfolio-wrapper-text">
                      <title>doctor near me</title>
                      <h3 className="h3-title">Medical Outreach</h3>
                      <p>Ibusa 2007</p>
                    </div>
                  </div>
                </div>
                {/* 4 */}
                <div className="portfolio md-3 medical-outreach">
                  <title>doctor near me</title>
                  <div className="portfolio-wrapper">
                    <title>doctor near me</title>
                    <div
                      className="portfolio-img back-img"
                      style={{
                        backgroundImage:
                          "url('https://i.ibb.co/mB461rL/dr-isioma-okobah-medical-outreach16.jpg')",
                      }}
                    ></div>
                    <div className="portfolio-wrapper-text">
                      <title>doctor near me</title>
                      <h3 className="h3-title">Medical Outreach</h3>
                      <p>Asaba 2018</p>
                    </div>
                  </div>
                </div>
                {/* 5 */}
                <div className="portfolio md-3 women-and-Children">
                  <title>doctor near me</title>
                  <div className="portfolio-wrapper">
                    <title>doctor near me</title>
                    <div
                      className="portfolio-img back-img"
                      style={{
                        backgroundImage:
                          "url('https://i.ibb.co/86SbCF0/dr-isioma-okobah-medical-outreach6.jpg')",
                      }}
                    ></div>
                    <div className="portfolio-wrapper-text">
                      <title>doctor near me</title>
                      <h3 className="h3-title">Women and Children</h3>
                      <p>Agbor 2018</p>
                    </div>
                  </div>
                </div>
                {/* 6 */}
                <div className="portfolio md-6 medical-outreach">
                  <title>doctor near me</title>
                  <div className="portfolio-wrapper">
                    <title>doctor near me</title>
                    <div
                      className="portfolio-img back-img"
                      style={{
                        backgroundImage:
                          "url('https://i.ibb.co/kXKvYZ9/dr-isioma-okobah-medical-outreach3.jpg')",
                      }}
                    ></div>
                    <div className="portfolio-wrapper-text">
                      <title>doctor near me</title>
                      <h3 className="h3-title">Medical Outreach</h3>
                      <p>Warri 2014</p>
                    </div>
                  </div>
                </div>
                {/* 7 */}
                <div className="portfolio md-6 medical-outreach">
                  <title>doctor near me</title>
                  <div className="portfolio-wrapper">
                    <title>doctor near me</title>
                    <div
                        className="portfolio-img back-img"
                        style={{
                          backgroundImage:
                              "url('https://i.ibb.co/cC8pMyB/dr-isioma-okobah-medical-outreach9.jpg')",
                        }}
                    ></div>
                    <div className="portfolio-wrapper-text">
                      <title>doctor near me</title>
                      <h3 className="h3-title">Medical Outreach</h3>
                      <p>Onicha Ugbo 2015</p>
                    </div>
                  </div>
                </div>
                {/* 8 */}
                <div className="portfolio md-3 medical-outreach">
                  <title>doctor near me</title>
                  <div className="portfolio-wrapper">
                    <title>doctor near me</title>
                    <div
                        className="portfolio-img back-img"
                        style={{
                          backgroundImage:
                              "url('https://i.ibb.co/JFVysfL/dr-isioma-okobah-medical-outreach10.jpg')",
                        }}
                    ></div>
                    <div className="portfolio-wrapper-text">
                      <title>doctor near me</title>
                      <h3 className="h3-title">Medical Outreach</h3>
                      <p>Ezi 2016</p>
                    </div>
                  </div>
                </div>
                {/* 9 */}
                <div className="portfolio md-3 women-and-Children">
                  <title>doctor near me</title>
                  <div className="portfolio-wrapper">
                    <div
                        className="portfolio-img back-img"
                        style={{
                          backgroundImage:
                              "url('https://i.ibb.co/bNyHWdW/dr-isioma-okobah-women-and-children-outreach6.jpg')",
                        }}
                    ></div>
                  </div>
                </div>
                    <div className="portfolio-wrapper-text">
                      <title>doctor near me</title>
                      <h3 className="h3-title">Women and Children</h3>
                      <p>Onicha Ugbo 2016</p>
                    </div>
              {/* 10 */}
              <div className="portfolio md-3 medical-outreach">
                <title>doctor near me</title>
                <div className="portfolio-wrapper">
                  <div
                      className="portfolio-img back-img"
                      style={{
                        backgroundImage:
                            "url('https://i.ibb.co/5FSBB2n/dr-isioma-okobah-medical-outreach19.jpg')",
                      }}
                  ></div>
                  <div className="portfolio-wrapper-text">
                    <title>doctor near me</title>
                    <h3 className="h3-title">Medical Outreach</h3>
                    <p>Honduras 2007</p>
                  </div>
                </div>
              </div>
              {/* 11 */}
              <div className="portfolio md-3 women-and-Children">
                <title>doctor near me</title>
                <div className="portfolio-wrapper">
                  <title>doctor near me</title>
                  <div
                      className="portfolio-img back-img"
                      style={{
                        backgroundImage:
                            "url('https://i.ibb.co/0c2hg7f/dr-isioma-okobah-women-and-children-outreach3.jpg')",
                      }}
                  ></div>
                  <div className="portfolio-wrapper-text">
                    <title>doctor near me</title>
                    <h3 className="h3-title">Women and Children Outreach</h3>
                    <p>Okpanan 2020</p>
                  </div>
                </div>
              </div>
              {/* 12 */}
              <div className="portfolio md-6 rural-health">
                <title>doctor near me</title>
                <div className="portfolio-wrapper">
                  <div
                      className="portfolio-img back-img"
                      style={{
                        backgroundImage:
                            "url('https://i.ibb.co/kcz74R3/dr-isioma-okobah-rural-health-center.jpg')",
                      }}
                  ></div>
                  <div className="portfolio-wrapper-text">
                    <title>doctor near me</title>
                    <h3 className="h3-title">Rural Health</h3>
                    <p>Igbodo, Est 2012 </p>
                  </div>
                </div>
              </div>
            {/* 13 */}
            <div className="portfolio md-6 women-and-Children">
              <title>doctor near me</title>
              <div className="portfolio-wrapper">
                <title>doctor near me</title>
                <div
                    className="portfolio-img back-img"
                    style={{
                      backgroundImage:
                          "url('https://i.ibb.co/5xsfzQc/dr-isioma-okobah-women-and-children-outreach7.jpg')",
                    }}
                ></div>
                <div className="portfolio-wrapper-text">
                  <title>doctor near me</title>
                  <h3 className="h3-title">Women and Children Outreach</h3>
                  <p>Ezi 2018</p>
                </div>
              </div>
            </div>
            {/* 14 */}
            <div className="portfolio md-3 rural-health">
              <title>doctor near me</title>
              <div className="portfolio-wrapper">
                <div
                    className="portfolio-img back-img"
                    style={{
                      backgroundImage:
                          "url('https://i.ibb.co/2FvkdsV/dr-isioma-okobah-rural-health3.jpg')",
                    }}
                ></div>
                <div className="portfolio-wrapper-text">
                  <title>doctor near me</title>
                  <h3 className="h3-title">Rural Health</h3>
                  <p>Igbodo 2021</p>
                </div>
              </div>
            </div>
            {/* 15 */}
            <div className="portfolio md-3 rural-health">
              <title>doctor near me</title>
              <div className="portfolio-wrapper">
                <title>doctor near me</title>
                <div
                    className="portfolio-img back-img"
                    style={{
                      backgroundImage:
                          "url('https://i.ibb.co/sFp62nt/dr-isioma-okobah-children.jpg')",
                    }}
                ></div>
                <div className="portfolio-wrapper-text">
                  <title>doctor near me</title>
                  <h3 className="h3-title">Rural Health</h3>
                  <p>Bomadi 2020</p>
                </div>
              </div>
            </div>
            {/* 16 */}
            <div className="portfolio md-3 women-and-Children">
              <title>doctor near me</title>
              <div className="portfolio-wrapper">
                <title>doctor near me</title>
                <div
                    className="portfolio-img back-img"
                    style={{
                      backgroundImage:
                          "url('https://i.ibb.co/hD0kzTp/dr-isioma-okobah-women-and-children-outreach10.jpg')",
                    }}
                ></div>
                <div className="portfolio-wrapper-text">
                  <title>doctor near me</title>
                  <h3 className="h3-title">Women and Children</h3>
                  <p>Owa-Alero 2019</p>
                </div>
              </div>
            </div>
            {/* 17 */}
            <div className="portfolio md-3 rural-outreach">
              <title>doctor near me</title>
              <div className="portfolio-wrapper">
                <title>doctor near me</title>
                <div
                    className="portfolio-img back-img"
                    style={{
                      backgroundImage:
                          "url('https://i.ibb.co/F4xq6JH/dr-isioma-okobah-rural-health.jpg')",
                    }}
                ></div>
                <div className="portfolio-wrapper-text">
                  <title>doctor near me</title>
                  <h3 className="h3-title">Rural Health</h3>
                  <p>Agbor 2022 </p>
                </div>
              </div>
            </div>
            {/* 18 */}
            <div className="portfolio md-6 women-and-children">
              <title>doctor near me</title>
              <div className="portfolio-wrapper">
                <title>doctor near me</title>
                <div
                    className="portfolio-img back-img"
                    style={{
                      backgroundImage:
                          "url('https://i.ibb.co/0XPHjtT/dr-isioma-okobah-children3.jpg')",
                    }}
                ></div>
                <div className="portfolio-wrapper-text">
                  <title>doctor near me</title>
                  <h3 className="h3-title">Women and Children Outreach</h3>
                  <p>Umunede 2017</p>
                  </div>
              </div>
            </div>
    </div>
      </div>
</Col>
        </Row>
      </Container>
    </div>

  );
}

export default Portfolio;
